// libs
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Placeholders
import imagePlaceholder from '../../../../assets/images/placeholder-default.svg';
import placeholderProtected from '../../../../assets/images/placeholder-protected-fr.svg';
import placeholderUnavailable from '../../../../assets/images/placeholder-unavailable.svg';

// placeholders
const placeholders = {
  default: {
    size_1024: imagePlaceholder,
  },
  'no-diffusion-rights': {
    size_1024: placeholderProtected,
  },
  geoblocked: {
    size_1024: placeholderProtected,
  },
  unavailable: {
    size_1024: placeholderUnavailable,
  },
};

// IMAGE
class Image extends Component {
  static propTypes = {
    alt: PropTypes.string,
    className: PropTypes.string,
    mediaUrl: PropTypes.string,
    onLoad: PropTypes.func,
    placeholder: PropTypes.oneOf(['default', 'no-diffusion-rights', 'geoblocked', 'unavailable']),
  };
  static defaultProps = {
    alt: '',
    className: '',
    mediaUrl: '',
    onLoad: null,
    placeholder: 'default',
  };

  constructor(props) {
    super(props);
    this.handleError = this.handleError.bind(this);
    this.placeholder = false;
  }

  handleError(e) {
    const { placeholder } = this.props;
    this.placeholder = true;
    e.target.setAttribute('src', placeholders[placeholder].size_1024);
    e.target.onerror = null;
  }

  render() {
    const { handleError } = this;
    const { className, alt, mediaUrl, onLoad, placeholder } = this.props;

    return (
      <picture className={classNames(className, { [`${className}--placeholder ${className}--${placeholder}`]: this.placeholder })}>
        <img
          alt={alt}
          src={mediaUrl}
          onError={handleError}
          onLoad={onLoad}
        />
      </picture>
    );
  }
}

export default Image;



// WEBPACK FOOTER //
// ./src/app/components/tools/image/Image.js